import React, { PureComponent } from 'react';
import style from './styles/style.module.css';

export default class Hero extends PureComponent {
    render() {
        return (
            <div className={ style.hero } data-banner={ !!this.props.banner }
            data-tint={ !!this.props.tint }>
                <div className={ style.heroContent }>
                    { !this.props.banner &&
                        <div className={ style.back }>
                            { this.props.background }
                        </div>
                    }
                    { !this.props.banner &&
                        <div className={ style.fore }>
                            { this.props.foreground }
                        </div>
                    }
                    { this.props.banner &&
                        <div className={ style.banner }>
                            { this.props.banner }
                        </div>
                    }
                    <div className={ style.textWrapper }>
                        <div className={ style.text }>
                            <div className={ style.textContent }>
                                { this.props.content }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
